import * as React from 'react';
import { cn } from '@/lib/utils';

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
    size?: number;
    className?: string;
}

export function Spinner({ size = 40, className, ...props }: SpinnerProps) {
    const dotSize = size / 10;
    const orbitDistance = size / 2 - dotSize + 'px';

    return (
        <div
            className={cn(
                'relative flex items-center justify-center',
                className
            )}
            style={{ width: size, height: size }}
            {...props}
            role="status"
            aria-label="Loading"
        >
            {/* Outer rotating ring */}
            <div
                className="absolute rounded-full border-t-2 border-b-2 border-primary animate-spin"
                style={{ width: size, height: size }}
            />

            {/* Inner pulsing ring */}
            <div
                className="absolute rounded-full border-2 border-primary/40 animate-pulse"
                style={{ width: size * 0.75, height: size * 0.75 }}
            />

            {/* Orbital dots */}
            {[...Array(6)].map((_, i) => (
                <div
                    key={i}
                    className="absolute rounded-full bg-primary animate-orbit"
                    style={
                        {
                            width: dotSize,
                            height: dotSize,
                            '--orbit-distance': orbitDistance,
                            animationDelay: `${i * 0.2}s`,
                        } as React.CSSProperties
                    }
                />
            ))}

            {/* Center dot - pulsing */}
            <div
                className="absolute bg-primary rounded-full animate-pulse"
                style={{ width: dotSize * 2, height: dotSize * 2 }}
            />

            <span className="sr-only">Loading...</span>
        </div>
    );
}
